import { ResponsiveImageMapper } from "@omni/mappers/components/image/responsiveImage.mapper";
import { bannerSlider } from "@omni/ui/brand/bannerSlider/bannerSlider.styles";
import { useMapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";

import { useBannerSliderContext } from "@/components/BannerSlider/context/bannerSlider.context";
import { ImageDefault } from "@/components/General/Image/image.default";
import { ImageLink } from "@/components/General/ImageLink/imageLink";

type Props = {
    className?: string;
};

export const Slide = ({ className }: Props) => {
    const { slides } = useBannerSliderContext();
    const { index } = useMapped();

    const slide = slides.at(index);

    if (!slide) {
        return null;
    }

    const imageProps = ResponsiveImageMapper.fromCoreToFrontEnd({
        image: slide.responsiveImage,
        mobileImage: slide.responsiveImageMobile,
        lazyLoading: slide.lazyLoading
    });

    if (!imageProps) {
        return null;
    }

    const { slider_slides_slide } = bannerSlider();

    return (
        <>
            {!slide.href && (
                <ImageDefault
                    {...imageProps}
                    trackingProps={slide.trackingProps}
                    intersectionOptions={{
                        threshold: 0.4
                    }}
                    className={cn(slider_slides_slide(), className)}
                />
            )}
            {slide.href && (
                <ImageLink
                    {...imageProps}
                    href={slide.href}
                    advisorId={undefined}
                    advisorType={undefined}
                    advisorMode={undefined}
                    openInNewTab={slide.openInNewTab}
                    trackingProps={slide.trackingProps}
                    intersectionOptions={{
                        threshold: 0.4
                    }}
                    className={cn(slider_slides_slide(), className)}
                />
            )}
        </>
    );
};
